import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { TextField, Button, Select, MenuItem } from '@mui/material';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { resetTimout, registerWithEmailAndPassword } from "./common/FirebaseSupervisor";
import { isValidSession, getAdminID } from "../store/action/RemoteActionSupervisor";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";

const SupervisorAdd = (props) => {
    const [language, setLanguage] = useState("");
    const [mailID, setMailID] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [adminRole, setAdminRole] = useState("Admin");
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);
    const navigate = useNavigate();

    const handleMailIDChange = (e) => {
        resetTimout();
        setMailID(e.target.value);
    };

    const handlePasswordChange = (e) => {
        resetTimout();
        setPassword(e.target.value);
    };

    const handleFirstNameChange = (e) => {
        resetTimout();
        setFirstName(e.target.value);
    };

    const handleLastNameChange = (e) => {
        resetTimout();
        setLastName(e.target.value);
    };

    const handleAdminRoleChange = (e) => {
        resetTimout();
        setAdminRole(e.target.value);
    };

    const addSupervisor = async () => {
        const regexPassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        const regexEmail = /^[a-z0-9_.@]+$/i;

        if (!isValidSession()) {
            return;
        }

        if (!mailID || !password || !firstName || !lastName || !adminRole) {
            alert(getMultiLanguageMessage('msg_Incomplete_Input_Error', language));
            return;
        }
        if (!regexEmail.test(mailID)) {
            alert(getMultiLanguageMessage('msg_InvalidEMail_Error', language));
            return;
        }
        if (!regexPassword.test(password)) {
            alert(getMultiLanguageMessage('msg_InvalidPasswordRule_Error', language));
            return;
        }

        if (window.confirm(getMultiLanguageMessage('msg_Update_Confirm', language))) {
            setIsButtonClicked(true);
            let adminId = getAdminID();

            await registerWithEmailAndPassword(firstName, lastName, adminRole, mailID, password, adminId, false).then(async url => {
                if (url && url.length) {
                    setIsSubmitSuccess(true);
                    navigate("/supervisorlist");
                } else {
                    alert(getMultiLanguageMessage('msg_Server_Error', language));
                    setIsSubmitSuccess(false);
                }
            });
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        if (props?.supervisor?.length > 0) {
        }
    }, [props.supervisor]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        props.actionToggleNavBar(true);
        props.actionToggleSideBar(true);
        props.actionToggleFooter(true);
    }, []);

    return ((props?.supervisor?.length > 0) ?
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-SupervisorAdd')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">
                        {/* .row */}

                        <table width='100%'>
                            <tbody>
                                <tr>
                                    <td className='td-type2-col1'>{translate('EMail')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_MailID"
                                            sx={{ width: '50ch' }}
                                            value={mailID}
                                            defaultValue={mailID}
                                            onChange={handleMailIDChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Password')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_Agatha"
                                            sx={{ width: '50ch' }}
                                            value={password}
                                            defaultValue={password}
                                            onChange={handlePasswordChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('FirstName')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_FirstName"
                                            sx={{ width: '24.5ch' }}
                                            value={firstName}
                                            defaultValue={firstName}
                                            onChange={handleFirstNameChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('LastName')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_LastName"
                                            sx={{ width: '24.5ch' }}
                                            value={lastName}
                                            defaultValue={lastName}
                                            onChange={handleLastNameChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('AdminRole')}</td>
                                    <td className='td-type2-col2'>
                                        <Select id="id_AdminRole" value={adminRole} onChange={handleAdminRoleChange} className="input-item-label">
                                            <MenuItem value={'Admin'}>{'Admin'}</MenuItem>
                                            <MenuItem value={'SysAdmin'}>{'SysAdmin'}</MenuItem>
                                        </Select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {isButtonClicked &&
                            <>
                                <div className="gaps" />
                                <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                            </>
                        }
                        <div className="gaps-2x" />
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <div className="gaps-2x d-sm-none" />
                            <span className="color-success">
                                {isSubmitSuccess &&
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                }
                            </span>
                        </div>

                        {/* 10px gap */}
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => addSupervisor()}>{translate('btnAddNew')}</Button>
                            <div className="gaps-2x d-sm-none" />
                        </div>
                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div>
            {/* .tab-content */}
        </div>
        : "");
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        supervisor: state.remote.supervisor
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter
})(SupervisorAdd);
